import { FormRender } from '../../../forms/FormRenderer/types'
import { CustomerModelTypeAndAddress } from '../../../specificComponents/Customers/types'
import { getDictionaryStates } from '../../globals/countries'
import { TwinDictionary } from '../../globals/dictionary'
import { sortCountries } from '../../globals/sortCountries'
import { getDictionaryCountries } from '../../reducers/getters'
import useCountryState from '../useCountry'
import useTwinTranslation from '../useTwinTranslation'

interface CreateCustomerAddressProps {
    createAddress: boolean
    data?: TwinDictionary
}

const useCreateCustomerAndAddress = ({ createAddress, data }: CreateCustomerAddressProps) => {
    const { country, setCountry } = useCountryState({ defaultCountry: '' })
    const {t} = useTwinTranslation()
    const addressFields:  FormRender<CustomerModelTypeAndAddress> =[]
    const addressFieldsCSV: FormRender<any> = []
    if(createAddress){
        addressFields.push(
            {
                cols: 3,
                elements: [
                    {
                        name: 'nameAddress',
                        label: t('nameAddress', 'Nombre de la dirección'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                        required: true
                    },
                    {
                        name: 'name_to',
                        label: t('recipientName', 'Nombre del receptor'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                        required: true,
                        value: data?.name_to ?? data?.name
                    },
                    {
                        name: 'surname_to',
                        label: t('recipientSurname', 'Apellido del receptor'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                        value: data?.surname_to ?? data?.surname
                    },
                ],
            },
            {
                cols: 3,
                title: t('address', 'Dirección'),
                elements: [
                    {
                        name: 'address',
                        label: t('address', 'Dirección'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                        required: true
                    },
                    {
                        name: 'additional_address',
                        label: t('additional_address', 'Dirección adicional'),
                        component: 'InputWithLabelMargin',
                        type: 'text'
                    },
                    {
                        name: 'postal_code',
                        label: t('postalCode', 'Código Postal'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                        required: true
                    },
                    {
                        name: 'city',
                        label: t('city', 'Ciudad'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                        required: true
                    },
                    {
                        name: 'country',
                        label: t('country', 'País'),
                        component: 'CustomSelectWithSearchBar',
                        items: getDictionaryCountries(),
                        sortFunction: sortCountries,
                        required: true,
                        value: '',
                        onChange: (value: string) => setCountry(value)
                    },
                    {
                        name: 'state',
                        label: t('state', 'Provincia'),
                        component: 'CustomSelectWithSearchBar',
                        sortItems: true,
                        items: getDictionaryStates(country),
                        required: true,
                        value: ''
                    },
                    {
                        name: 'lat',
                        label: t('latitude', 'Latitud'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                    },
                    {
                        name: 'long',
                        label: t('longitude', 'Longitud'),
                        component: 'InputWithLabelMargin',
                        type: 'text',
                    },
                ]
            }
        )
        addressFieldsCSV.push(
        {
            cols: 2,
            elements: [
                {
                    name: 'posNameAddressColumn',
                    label: t('posNameAddressColumn', 'Posición columna nombre de la dirección'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                    required: true
                },
                {
                    name: 'posNameToColumn',
                    label: t('posRecipientNameColumn', 'Posición columna nombre del receptor'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                    required: true
                },
                {
                    name: 'posSurnameToColumn',
                    label: t('posRecipientSurnameColumn', 'Posición columna apellido del receptor'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                },
            ],
        },
        {
            cols: 2,
            title: t('address', 'Dirección'),
            elements: [
                {
                    name: 'posAddressColumn',
                    label: t('posAddressColumn', 'Posición columna dirección'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                    required: true
                },
                {
                    name: 'posAddressAdditionalColumn',
                    label: t('posAddressAdditionalColumn', 'Posición columna dirección adicional'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                },
                {
                    name: 'posPostalCodeColumn',
                    label: t('posPostalCodeColumn', 'Posición columna código postal'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                    required: true
                },
                {
                    name: 'posCityColumn',
                    label: t('posCityColumn', 'Posición columna ciudad'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                    required: true
                },
                {
                    name: 'posCountryColumn',
                    label: t('posCountryColumn', 'Posición columna país'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                    required: true
                },
                {
                    name: 'posStateCountryColumn',
                    label: t('posStateCountryColumn', 'Posición columna provincia'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                    required: true
                }
            ]
        })
    }
    return { addressFields, addressFieldsCSV }
}


export default useCreateCustomerAndAddress